import { __decorate } from "tslib";
import InstructorsTableBase from '@/classes/InstructorsTableBase';
import { InstructorTableRowType } from '@/enums/InstructorTableRowType';
import Component from "vue-class-component";
import { Prop, Ref } from 'vue-property-decorator';
import InstructorTable from '@/classes/InstructorTable';
import AddClientForm from '@/components/AddClientForm.vue';
import { InstructorTableCellType } from '@/enums/InstructorTableCellType';
import _ from 'lodash';
import { NotificationTypes } from "@/enums/NotificationTypes";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import store from "@/store";
import { isDesktop } from "@/utils/isDesktop";
import { validateOverlap, formatOverlapError } from '@/utils/overlapValidation';
import Snackbar from '@/components/Snackbar.vue';
let InstructorsTableAvailableCell = class InstructorsTableAvailableCell extends InstructorsTableBase {
    dataSource;
    rowData;
    hour;
    cellContent;
    async showCellContent(timeout) {
        await this.$nextTick();
        this.cellContent?.classList.add('cell-content-visible');
        if (timeout !== undefined) {
            setTimeout(() => {
                this.hideCellContent();
            }, timeout);
        }
    }
    async hideCellContent() {
        this.cellContent?.classList.remove('cell-content-visible');
    }
    async removeAvailableCellToCurrentUser() {
        if (!this.rowData.isCurrentUserRow()
            && !await ConfirmDialog.open('Upozornění', 'Opravdu chcete ovlivnit dostupnost instruktora? O této změně bude informován.')) {
            return;
        }
        if (!this.rowData.isCurrentUserRow()) {
            await store.dispatch('notification/send', {
                instructor: this.rowData.instructorId,
                message: `Admin upravil tvou dostupnost dne ${this.dataSource.date.format('D. M. YYYY')} od ${this.hour}:00`,
                type: NotificationTypes.ERROR,
                urgency: this.notificationUrgency,
                link: { name: 'InstructorsTimeScheduleWithDate', params: { date: this.dataSource.date.format('YYYY-MM-DD') } },
            });
        }
        if (this.rowData.rowType === InstructorTableRowType.INSTRUCTOR && (this.rowData.isCurrentUserRow() || this.isAdmin())) {
            const index = this.rowData.cells.findIndex(x => x.hour === this.hour);
            if (index !== -1) {
                this.rowData.cells.splice(index, 1);
            }
        }
        await this.updateDataSource();
    }
    addClient() {
        const availableHourCount = this.getAvailableHourCount(this.rowData, this.hour);
        document.dispatchEvent(new CustomEvent('addClient', { detail: {
                from: this.getDateTimeWithHours(this.dataSource.date, this.hour),
                availableHours: availableHourCount,
                row: this.rowData,
                hour: this.hour
            } }));
    }
    canPasteToCell() {
        const cell = this.$store.getters['instructorTable/getCopyPasteCell'];
        if (cell === undefined) {
            return false;
        }
        if (cell.length === 1) {
            return true;
        }
        for (let i = 1; i < cell.length; i++) {
            if (this.hour + i > this.dataSource.toHour) {
                return false;
            }
            if (this.rowData.rowType === InstructorTableRowType.BLOCK) {
                if (this.rowData.cells.some(x => x.hour === this.hour + i
                    && (x.cellType === InstructorTableCellType.RESERVED
                        || x.cellType === InstructorTableCellType.PAUSE))) {
                    return false;
                }
            }
            else {
                if (!this.rowData.cells.some(x => x.cellType === InstructorTableCellType.AVAILABLE
                    && x.hour === this.hour + i)) {
                    return false;
                }
            }
        }
        return true;
    }
    async paste() {
        const cell = InstructorTable.loadCellFromObject(_.cloneDeep(this.$store.getters['instructorTable/getCopyPasteCell']), this.rowData);
        cell.hour = this.hour;
        // Overlap validation for instructor rows
        if (this.rowData.rowType === InstructorTableRowType.INSTRUCTOR) {
            const instructorRow = this.rowData;
            // Get reserved cells for this instructor row
            const reservedCells = instructorRow.cells
                .filter(c => c.cellType === InstructorTableCellType.RESERVED)
                .map(c => {
                const reservedCell = c;
                return {
                    type: 'RESERVED',
                    hour: reservedCell.hour,
                    length: reservedCell.length,
                    service: (reservedCell.service || 'ski'),
                    clientNames: reservedCell.clients?.map(client => client.name) || [],
                };
            });
            // Validate overlap
            const validation = validateOverlap(reservedCells, {
                instructorId: instructorRow.instructorId,
                hour: this.hour,
                length: cell.length,
            });
            if (!validation.valid && validation.error) {
                // Fill in instructor name for the error message
                if (validation.error.conflict) {
                    const instructor = this.$store.getters['instructor/get'](instructorRow.instructorId);
                    validation.error.conflict.instructorName = instructor
                        ? `${instructor.data.name} ${instructor.data.surname}`
                        : 'Neznámý';
                    Snackbar.error(formatOverlapError(validation.error.conflict));
                }
                else {
                    Snackbar.error(validation.error.message);
                }
                return; // Abort paste
            }
        }
        for (let i = 0; i < cell.length; i++) {
            const cellIndexToBeReplaced = this.rowData.cells.findIndex(x => x.hour === this.hour + i);
            if (cellIndexToBeReplaced > -1) {
                this.rowData.cells.splice(cellIndexToBeReplaced, 1);
            }
        }
        this.rowData.cells.push(cell);
        await cell.notifyInstructor(`Nová výuka dne ${this.dataSource.date.format('D. M. YYYY')} od ${cell.hour}:00`, NotificationTypes.SUCCESS, { name: 'InstructorsTimeScheduleWithDate', params: { date: this.dataSource.date.format('YYYY-MM-DD') } });
        await this.updateDataSource();
        this.$store.dispatch('instructorTable/clearCell');
    }
    get isDesktop() {
        return isDesktop();
    }
    get isBlockRowCell() {
        return this.rowData.rowType === InstructorTableRowType.BLOCK;
    }
};
__decorate([
    Prop({ required: true })
], InstructorsTableAvailableCell.prototype, "dataSource", void 0);
__decorate([
    Prop({ required: true })
], InstructorsTableAvailableCell.prototype, "rowData", void 0);
__decorate([
    Prop({ required: true })
], InstructorsTableAvailableCell.prototype, "hour", void 0);
__decorate([
    Ref('cellContent')
], InstructorsTableAvailableCell.prototype, "cellContent", void 0);
InstructorsTableAvailableCell = __decorate([
    Component({
        components: {
            AddClientForm
        }
    })
], InstructorsTableAvailableCell);
export default InstructorsTableAvailableCell;
